<template>
    <div style="background-color: white;min-height: 650px;padding: 20px;box-sizing: border-box;">
        <div class="flex items-center">
            <i class="el-icon-arrow-left font-bold text-xl cursor-pointer" style="color: #999999" @click="goBack" />
            <p class="product_name">{{ project_info.project_ename }}</p>
        </div>

        <div class="product-content">
            <img class="product-logo" :src="project_info.project_logo">
            <div class="middle-content">
                <p class="product_name" style="font-size: 14px;margin-bottom: 4px">{{ project_info.project_ename }}</p>
                <div style="display: flex;gap: 5px; flex-wrap: wrap;">
                    <template v-if="needsCycleSelection">
                        <div v-if="!isNilProject" class="price-container">
                            <div>
                                <p class="font_red font_bold">Current window (accelerated)</p>
                                <p class="price-date" v-if="currentCycle">register by {{ formatStoreDate(currentCycle.register_ddl_date) }}</p>
                            </div>
                            <p class="price">Fee: {{ nimCurrentTrackPrice }} {{ enableShowPrice == true ? reviewCurrency : 'Free'}}</p>
                        </div>
                        <div v-if="!isNilProject && hasLaterCycle" class="price-container">
                            <div>
                                <p class="font_red font_bold">Later window (standard)</p>
                                <p class="price-date" v-if="laterCycle">register by {{ formatStoreDate(laterCycle.register_ddl_date) }}</p>
                            </div>
                            <p class="price">Fee: {{ nimLaterTrackPrice }} {{ enableShowPrice == true ? reviewCurrency : 'Free'}}</p>
                        </div>
                        <div class="price-container">
                            <div>
                                <p class="font_red font_bold">{{ isNilProject ? 'NIL Registration' : 'NIL (combo)' }}</p>
                                <p class="price-date">list price from project normal slot</p>
                            </div>
                            <p class="price">Fee: {{ nimNilPriceLabel }} {{ enableShowPrice == true ? reviewCurrency : 'Free'}}</p>
                        </div>
                    </template>
                    <template v-else>
                    <div v-if="showStandardEarlyBirdPrice" class="price-container">
                        <div>
                            <p class="font_red font_bold">Early Bird Registration</p>
                            <p class="price-date">register by {{ formatStoreDate(earlyBirdDeadline) }}</p>
                        </div>
                        <p class="price">Fee: {{ earlyBirdReviewPrice }} {{ enableShowPrice == true ? reviewCurrency : 'Free'}}</p>
                    </div>
                    <div class="price-container">
                        <div>
                            <p class="font_red font_bold">Normal Registration</p>
                            <p class="price-date">register by {{ formatStoreDate(standardDeadline) }}
                            </p>
                        </div>
                        <p class="price">Fee: {{ project_info.project_price == 0 ||  enableShowPrice == false? 'Free' : standardReviewPrice +
                            ' ' + reviewCurrency }}</p>
                    </div>
                    </template>
                    <div v-if="project_info.project_price !== 0 && enableShowPrice == true" class="price-container">
                        <div>
                            <p class="font_red font_bold">Fee Reduction</p>
                        </div>
                        <p class="price-reduction font_red">
                            <span v-if="reduction_level8 === 0">Not Available</span>
                            
                            <span v-else @click="showFeeReduction" class="font_under_line" style="font-family: centurygothic;">
                                {{
                                `${reduction_level1} to ${reduction_level8} ${project_info.project_price_currency}`
                            }}
                            <i class="el-icon-info" 
                                style="color: #909399; cursor: pointer; font-size: 14px;"
                                @click="showFeeReduction">
                            </i>
                            </span>
                                
                            
                        </p>
                    </div>
                </div>
            </div>
            <div class="right-content">
                <div  v-if="project_info.project_need_qualification && project_info.project_need_qualification == 'YES'">    
                    <p style="font-size: 16px;display: inline-block;margin-right: 10px;">This program requires qualification <br>and it does not allow open registration</p>
                    
                </div>
                <div v-else>
                    <div v-if="!checkStartProject()">
                        <p style="font-size: 12px;display: inline-block;margin-right: 10px;">Registration opens on {{
                            convertChinaDateToEngDate(Date.parse(project_info.project_progress_start_date)) }}</p>
                        <div class="btn-disabled">Sign Up</div>
                    </div>
                    <div v-else>
                        <div class="btn-sign" v-if="checkEnableSign()" :class="checkSignResult == -1 ? 'btn-disabled' : ''"
                            @click="doSign">{{
                                checkSignResult == -1 ? 'Signed Up' : 'Sign Up' }}</div>
                        <div class="btn-disabled" v-if="checkSignClose()">Closed</div>
                        <!-- <p class="desc">This project is included in the EAE
                            Univesal Pass Portfolio. Consider purchasing the EAE Universal Pass for a better value
                            and access to more projects.</p> -->
                    </div>
                </div>
            </div>
        </div>
        <div style="margin-top: 30px;">
            <el-row :gutter="20">
                <el-col :span="16">
                    <div>
                        <!-- <p class="title">Introduction</p> -->
                        <!--Put the introduction below in el-tabs-->
                        <!-- select index 0 pane by default-->
                        <el-tabs v-model="activePane" @tab-click="handlePaneClick">
                            <el-tab-pane label="Introduction" name="introduction">
                                <div v-html="project_info.project_introduction"
                                    class="intro_container ql-snow ql-editor"></div>
                            </el-tab-pane>
                            <el-tab-pane label="Timeline" name="timeline">
                                <div class="timeline-container">
                                    <div class="timeline-note">
                                        <p><i>*Depends on the nature of the program, the entry in the timeline below
                                                either means entry of your exams (for academic test events) or entry of
                                                your projects/works/publications for review.</i></p>
                                        <p><i>**The date and time all refer to the designated local time for each
                                                continent. <b>Asia & Oceania: GMT+8, Europe & Africa: GMT+1, North &
                                                    SouthAmerica: GMT-4.</b></i></p>
                                    </div>
                                    <div class="timeline-cycles">
                                        <div v-for="cycle in project_info.projectManage?.entry_date" :key="cycle.name"
                                            class="timeline-cycle">
                                            <h3>{{ cycle.name }}</h3>

                                            <el-table :data="[cycle]">
                                                <el-table-column prop="start_date" label="Start Date for Entry">
                                                    <template slot-scope="scope">
                                                        {{ $dayjs(scope.row.start_date).format('MMMM DD, YYYY') }}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="ddl_date" label="Deadline for Entry">
                                                    <template slot-scope="scope">
                                                        {{ $dayjs(scope.row.ddl_date).format('MMMM DD, YYYY') }}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="announce_date" label="Announcement Date">
                                                    <template slot-scope="scope">
                                                        {{ $dayjs(scope.row.announce_date).format('MMMM DD, YYYY') }}
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>

                                    <div v-if="examTimes" class="exam-times">
                                        <h3>Exam Time</h3>
                                        <el-table :data="examTimes">
                                            <el-table-column prop="0" label="Name"></el-table-column>
                                            <el-table-column prop="1" label=" Start Time"></el-table-column>
                                            <el-table-column prop="2" label="End Time"></el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="Syllabus" name="syllabus" v-if="project_info.class_info">
                                <div class="syllabus-container">

                                    <div v-for="(value, key) in project_info.class_info" :key="key"
                                        class="syllabus-section">
                                        <h3>{{ key }}</h3>
                                        <ul>
                                            <li v-for="(item, index) in value" :key="index">
                                                <span v-if="typeof item === 'string'">{{ item }}</span>
                                                <template v-else-if="Array.isArray(item)">
                                                    <span>{{ item[0] }}</span>
                                                    <ul v-if="item.length > 1">
                                                        <li v-for="(subItem, subIndex) in item.slice(1)"
                                                            :key="subIndex">
                                                            {{ subItem }}
                                                        </li>
                                                    </ul>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="Sample Questions" name="sample_questions"
                                v-if="project_info.sample_quizes && project_info.sample_quizes.length > 0">
                                <div class="sample-questions-container">
                                    <div v-for="(quiz, index) in project_info.sample_quizes" :key="index"
                                        class="sample-question">
                                        <h3>Sample Question {{ index + 1 }}</h3>
                                        <p class="question"><strong>Question:</strong> {{ quiz.Question }}</p>
                                        <ul class="options">
                                            <li><strong>A:</strong> {{ quiz['Option A'] }}</li>
                                            <li><strong>B:</strong> {{ quiz['Option B'] }}</li>
                                            <li><strong>C:</strong> {{ quiz['Option C'] }}</li>
                                            <li><strong>D:</strong> {{ quiz['Option D'] }}</li>
                                        </ul>
                                        <p class="correct-answer"><strong>Correct Answer:</strong> {{ quiz['Correct Answer'] }}</p>
                                        <p class="explanation"><strong>Explanation:</strong> {{ quiz.Explanation }}</p>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>

                    </div>
                </el-col>
                <el-col :span="8">
                    <div>
                        <p class="title">Announcements & Updates</p>

                        <div class="announce-container">
                            <div v-for="(announce, index) in news" :key="index" class="announce-item"
                                @click="doShowNewsInfo(announce)">
                                <p class="announce-time">{{ $dayjs(announce.update_time * 1000).format('MMM D, YYYY') }}
                                </p>
                                <p class="announce-title">{{ announce.post_title }}</p>
                                <p class="announce-content" v-html="announce.post_content"></p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog :visible.sync="isShowDialog" title="Fee Reduction Policy" width="65%" :modal="true" :show-close="false" :modal-append-to-body="true" custom-class="showCustomEAEPolicyDialogStyle">
            <div>
                <EAE_Fee_Reduction_Policy :price_reductions="project_info.price_reductions"></EAE_Fee_Reduction_Policy>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showNewsDialog" width="70%" :title="selectNews.post_title">
            <div style="margin: 10px">
                <p v-html="selectNews.post_content" style="color: #666;font-size: 14px;line-height: 150%;margin: 1em 0;white-space: pre-line;"></p>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="showCycleDialog" title="Select Review Cycle" width="480px" :append-to-body="true">
            <p v-if="!isNilProject" style="color: #666; font-size: 13px; line-height: 18px; margin-bottom: 12px;">
                Signing up here creates a combo registration (NIL + this track) as two separate applications. The prices shown below are combo rates (NIL + {{ project_info.project_code || 'this track' }}) and represent list prices prior to applicable reductions.
            </p>
            <p v-if="!isNilProject" style="color: #666; font-size: 12px; line-height: 18px; margin-bottom: 12px;">
                If you already hold a NIL transcript, please use the
                <a href="/#/form/nim" style="color:#0f448C;text-decoration:underline;">NIM student form</a>
                and choose “Already have NIL”.
            </p>
            <p v-else style="color: #666; font-size: 13px; line-height: 18px; margin-bottom: 16px;">
                Please choose the review cycle for this NIL registration.
            </p>
            <el-radio-group v-model="selectedCycle" style="display: flex; flex-direction: column; align-items: flex-start;">
                <el-radio v-for="cycle in signupCycles" :key="cycle.name" :label="cycle.name" style="margin: 8px 0; white-space: normal; line-height: 20px;">
                    <span style="font-weight: 600;">{{ formatSignupCycleLabel(cycle) }}</span>
                    <span v-for="line in formatSignupCycleLines(cycle)" :key="cycle.name + line.key" style="display: block; color: #666; font-size: 12px; margin-top: 4px;">{{ line.text }}</span>
                </el-radio>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showCycleDialog = false">Cancel</el-button>
                <el-button type="primary" @click="confirmCycleAndSign">Continue</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {
    checkStudentIsInternationnal,
    createStudentApplication,
    createNimStudentRegistration,
    getNewsUpdateListByProject,
    getProjectInfoByCode,
    getREProjectInfo,
    checkEnableStudentSignupProject,
    postRequest,
    checkStudentEligibility,
    getPulsesByTagsAndUsers
} from '../../api/eae'
import {
    getUserId
} from '../../utils/store'
import {
    buildReviewCycleFeeLines,
    buildComboCycleCopyLines,
    buildReviewCycleOptionLabel,
    getEarlyBirdDeadline,
    getNimNilListPrice,
    getNimTrackListPrice,
    getOpenReviewCycles,
    getReviewCurrency,
    getStandardDeadline,
    isDeadlinePassed
} from '../../utils/nimReviewCycles'
import '../../assets/common/font.css'
import EAE_Fee_Reduction_Policy from '../../components/EAE_Fee_Reduction_Policy.vue';
export default ({
    name: 'index',
    components: {
        EAE_Fee_Reduction_Policy
    },
    data() {
        return {
            enableShowPrice:true,
            project_id: this.$route.query.project_id,
            project_info: {},
            productPrice: {},
            reduction_level: 0,
            reduction_level1: 0,
            reduction_level8: 0,
            reduction_price: 0,
            price_policy: '',
            news: [],
            isShowDialog: false,
            checkSignResult: -3,
            signMsg: '',
            showNewsDialog: false,
            selectNews: {},
            panes: ['introduction', 'timeline', 'syllabus'],
            activePane: 'introduction',
            showCycleDialog: false,
            selectedCycle: '',
            pendingSignStudentId: '',
            companionNilPrice: null,
            companionNilCode: '',
            companionNilProject: null
        }
    },
    computed: {
        signupCycles() {
            const entries = this.project_info.projectManage && this.project_info.projectManage.entry_date
            return getOpenReviewCycles(entries)
        },
        needsCycleSelection() {
            return this.project_info.project_BU === 'NIM' && this.signupCycles.length > 0
        },
        isNilProject() {
            return /NIL$/i.test(String(this.project_info.project_code || ''))
        },
        currentCycle() {
            return this.signupCycles[0] || null
        },
        laterCycle() {
            return this.signupCycles[1] || null
        },
        hasLaterCycle() {
            return !!this.laterCycle
        },
        showStandardEarlyBirdPrice() {
            return !!this.earlyBirdDeadline && !isDeadlinePassed(this.earlyBirdDeadline)
        },
        earlyBirdDeadline() {
            return getEarlyBirdDeadline(this.project_info)
        },
        standardDeadline() {
            return getStandardDeadline(this.project_info)
        },
        reviewCurrency() {
            return getReviewCurrency(this.project_info)
        },
        nimCurrentTrackPrice() {
            return getNimTrackListPrice(this.project_info, { isCurrent: true })
        },
        nimLaterTrackPrice() {
            return getNimTrackListPrice(this.project_info, { isCurrent: false })
        },
        nimNilPriceLabel() {
            if (this.isNilProject) {
                return getNimNilListPrice(this.project_info)
            }
            if (this.companionNilPrice !== null && this.companionNilPrice !== undefined && this.companionNilPrice !== '') {
                return this.companionNilPrice
            }
            return '—'
        },
        earlyBirdReviewPrice() {
            return this.project_info.project_earlybird_price
        },
        standardReviewPrice() {
            return this.project_info.project_price
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {

        convertChinaDateToEngDate(time) {
            return this.$dayjs(time).format("MMMM DD,YYYY")
        },

        loadCompanionNilPrice() {
            const code = String(this.project_info.project_code || '')
            if (!code || /NIL$/i.test(code) || this.project_info.project_BU !== 'NIM') {
                this.companionNilPrice = null
                this.companionNilCode = ''
                this.companionNilProject = null
                return
            }
            const year = (code.match(/^(\d{4})/) || [])[1]
            if (!year) {
                this.companionNilPrice = null
                this.companionNilCode = ''
                this.companionNilProject = null
                return
            }
            const nilCode = year + 'NIL'
            getProjectInfoByCode(nilCode).then((res) => {
                const project = res.data || {}
                this.companionNilPrice = project.project_price
                this.companionNilCode = project.project_code || nilCode
                this.companionNilProject = project
            }).catch(() => {
                this.companionNilPrice = null
                this.companionNilCode = nilCode
                this.companionNilProject = null
            })
        },

        checkStartProject() {
            if (this.project_info.project_progress_start_date) {
                let progress_start_date = this.project_info.project_progress_start_date
                let start_date = Date.parse(progress_start_date)
                console.log('start_date :' + start_date)
                let current_time = new Date().getTime()
                console.log('current_time :' + current_time)
                if (start_date >= current_time) {
                    return false
                } else {
                    return true
                }
            }
            return true
        },

        checkEnableSign() {
            if (this.project_info.deadline_date && this.project_info.deadline_date) {
                let deadline_date = this.project_info.deadline_date
                let current_time = new Date().getTime()
                if (deadline_date > current_time) {
                    return true
                }
            }
            return false
        },


        checkSignClose() {
            if (this.project_info.deadline_date && this.project_info.deadline_date) {
                let deadline_date = this.project_info.deadline_date
                let current_time = new Date().getTime()
                if (deadline_date < current_time) {
                    return true
                }
            }
            return false
            // project_info.deadline_date && project_info.deadline_date <= new Date.getTime()
        },

        async fetchData() {

            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            let projectResult = await getREProjectInfo(this.project_id)
            this.project_info = projectResult.data
            if (this.project_info.exam_time) {
                this.examTimes = this.project_info.exam_time.split('\n').map(row => {
                    return row.split('|').map(item => item.trim());
                });
            }
            this.doCheckStudent(this.project_info.project_code)
            this.loadCompanionNilPrice()

            // Use the new API with project_code as tag
            const user_ids = [
                '6743d93894c7841b468b456d',
                '68b11ba594c784d9568b4596',
                '68b11bcc94c784da568b458f',
                '68b11c6894c784d6568b458f',
                '68b11c2694c78460328b4571',
                '68b11d7c94c784d4568b4586',
                '68b11b7894c784da568b458e',
                '68b11b4194c784d6568b458e'
            ]
            
            const project_code = this.project_info.project_code || ''
            if (project_code) {
                try {
                    let newsResult = await getPulsesByTagsAndUsers(user_ids, project_code, 50, 0)
                    if (newsResult.data && newsResult.data.code === 0 && newsResult.data.data) {
                        this.news = newsResult.data.data.map(pulse => this.formatPulseData(pulse)).sort((a, b) => {
                            const timeA = a.display_date || a.created_at || a.update_time || 0
                            const timeB = b.display_date || b.created_at || b.update_time || 0
                            return timeB - timeA
                        })
                    } else {
                        this.news = []
                    }
                } catch (error) {
                    console.error('Failed to fetch news:', error)
                    this.news = []
                }
            } else {
                this.news = []
            }

            let reductionLevelResult = await postRequest({
                function: "getStudentReductionLevelsByProject",
                student_id: getUserId(),
                project_id: this.project_id
            });
            let reduction_level = reductionLevelResult.data.reduction_level;

            let signupResult = await checkEnableStudentSignupProject(getUserId(), this.project_id)
            this.checkSignResult = signupResult.data.code
            this.signMsg = signupResult.data.msg

            for (let i = 0; i < this.project_info.price_reductions.length; i++) {
                let price = this.project_info.price_reductions[i]
                if (price.level == reduction_level) {
                    this.reduction_price = price.reduction_price
                    break
                }
            }
            this.reduction_level1 = this.project_info.price_reductions[0].reduction_price
            this.reduction_level8 = this.project_info.price_reductions[7].reduction_price
            this.price_policy = this.project_info.price_policy

            loading.close();
        },

        doCheckStudent(project_code){
            checkStudentIsInternationnal(getUserId()).then((res)=>{
                //国外的学生 && 是2025Envirothon_Asia 不要显示，否则要显示
                this.enableShowPrice =(((res.data.data == true) && project_code == '2025Envirothon_Asia') == false) && this.project_info.project_BU !='WAO'
            })
        },

        doSign() {

            if (this.checkSignResult == -1 || this.checkSignResult == -3) {
                return
            }
            if (this.checkSignResult == -2) {
                this.$confirm(this.signMsg, "Entry Pass Required", { type: "warning", confirmButtonText: "Confirm", showCancelButton: false }).then(() => {
                }).catch(() => {
                })
                return
            }

            const studentId = getUserId();
            const localTime = this.getLocalBrowserTimeString();

            checkStudentEligibility(studentId, this.project_id, localTime).then((res) => {
                const result = res.data || {};
                const data = result.data || {};

                const hasErrors = Array.isArray(data.errors) && data.errors.length > 0;
                const isEligible = !!data.eligible && !hasErrors && result.code === 0;

                if (isEligible) {
                    if (this.needsCycleSelection) {
                        this.pendingSignStudentId = studentId
                        this.selectedCycle = ''
                        this.showCycleDialog = true
                        return
                    }
                    this.createSignedApplication(studentId, '')
                } else {
                    const errors = Array.isArray(data.errors) ? data.errors : [];
                    const warnings = Array.isArray(data.warnings) ? data.warnings : [];
                    const messages = [...errors, ...warnings];
                    const messageText = messages.length ? messages.join('<br>') : (result.msg || 'You are not eligible for this project.');

                    this.$alert(messageText, 'Not Eligible', {
                        type: 'warning',
                        confirmButtonText: 'OK',
                        dangerouslyUseHTMLString: true
                    }).catch(() => {
                        // dialog closed
                    });
                }
            }).catch(() => {
                this.$message.error('Failed to check eligibility. Please try again later.')
            })
        },

        formatSignupCycleLabel(cycle) {
            return buildReviewCycleOptionLabel(cycle, value => this.formatStoreShortDate(value))
        },

        formatSignupCycleLines(cycle) {
            if (!this.isNilProject) {
                return buildComboCycleCopyLines(cycle, this.project_info, this.companionNilProject, value => this.formatStoreDate(value), {
                    entryDates: this.signupCycles
                })
            }
            return buildReviewCycleFeeLines(cycle, this.project_info, value => this.formatStoreDate(value), {
                entryDates: this.signupCycles,
                isMakeup: false
            })
        },

        formatStoreShortDate(value) {
            if (!value) return ''
            return this.$dayjs(value).format('MMM D, YYYY')
        },

        formatStoreDate(value) {
            if (!value) return ''
            return this.$dayjs(value).format('MMMM DD, YYYY')
        },

        confirmCycleAndSign() {
            if (!this.selectedCycle || !this.signupCycles.some(cycle => cycle.name === this.selectedCycle)) {
                this.$message.warning('Please select a review cycle')
                return
            }
            this.showCycleDialog = false
            this.createSignedApplication(this.pendingSignStudentId || getUserId(), this.selectedCycle)
        },

        createSignedApplication(studentId, applicationCycle) {
            const finishSuccess = (appResult) => {
                    let project_name = this.project_info.project_ename
                    let info = 'You have successfully submitted an application for ' + project_name + '. Please go to "My Programs" and continue to complete your program registration by either veirfying a PASS or paying individually for the program. If you are eligible for a free registration, you still need to manually go through the payment process although it will have zero charges.'
                    if (this.project_info.project_BU == 'WAO') {
                        info = 'You have successfully submitted an application for ' + project_name + '. Please go to "My EAE" -  "My Activity Programs" to check your events and Official Courses. WAO offers an optional paid Study Course to help students prepare for the competition. To alleviate financial barriers, fee reductions are available and automatically applied at the payment page based on ' + "the student's country and tuition fee level. Students can choose to purchase the Study Course, but it is not mandatory for participation in the competition."
                    }
                    if (this.project_info.project_BU == 'NIM' && !this.isNilProject) {
                        info = 'Combo registration creates NIL + this track as two separate applications. Please pay each in My Programs.'
                    }
                    this.$confirm(info, "Continue to complete your project application", {
                        type: "success",
                        confirmButtonText: "Go to My Programs",
                        showCancelButton: true,
                        cancelButtonText: "Close"
                    }).then(() => {
                        this.$router.push('/home/programs');
                    }).catch(() => {
                        // User clicked Cancel, do nothing
                    });
            }

            // NIM store signup: use new registration modes (NIL-only / combo). Makeup stays on /form/nim.
            if (this.project_info.project_BU === 'NIM' && applicationCycle) {
                const mode = this.isNilProject ? 'nil_only' : 'combo'
                createNimStudentRegistration({
                    student_id: studentId,
                    project_code: this.project_info.project_code,
                    application_cycle: applicationCycle,
                    nim_registration_mode: mode,
                    email: '' // student already exists; backend createOrUpdate may still need fields from student record
                }).then((appRes) => {
                    let appResult = appRes.data
                    if (appResult.code == 0) {
                        finishSuccess(appResult)
                    } else {
                        const msg = (appResult && appResult.msg) ? String(appResult.msg) : ''
                        // Combo needs a fresh NIL; if student already has one, guide them to makeup on /form/nim.
                        // Combo blocked when student already has active NIL (backend pre-check or create).
                        if (mode === 'combo' && /active NIL|already joined this project|Already have NIL/i.test(msg)) {
                            this.$confirm(
                                'You already have an active NIL registration. Store Sign Up creates a combo (NIL + this track). If you already hold NIL, please use the NIM student form and choose “Already have NIL” (makeup).',
                                'Use makeup registration',
                                {
                                    type: 'warning',
                                    confirmButtonText: 'Go to NIM form',
                                    cancelButtonText: 'Close',
                                    distinguishCancelAndClose: true
                                }
                            ).then(() => {
                                this.$router.push({ path: '/form/nim' })
                            }).catch(() => {})
                            return
                        }
                        this.$message.warning(msg || 'Unable to create registration')
                    }
                }).catch(() => {
                    this.$message.error('Failed to create application. Please try again later.')
                })
                return
            }

            createStudentApplication(studentId, this.project_id, 'EAE-Store', applicationCycle, {
                enforce_nim_cycle: this.needsCycleSelection ? 1 : 0
            }).then((appRes) => {
                let appResult = appRes.data
                if (appResult.code == 0) {
                    finishSuccess(appResult)
                } else {
                    this.$message.warning(appResult.msg)
                }
            }).catch(() => {
                this.$message.error('Failed to create application. Please try again later.')
            })
        },

        getLocalBrowserTimeString() {
            const now = new Date();
            const pad = (n) => (n < 10 ? '0' + n : '' + n);
            const year = now.getFullYear();
            const month = pad(now.getMonth() + 1);
            const day = pad(now.getDate());
            const hours = pad(now.getHours());
            const minutes = pad(now.getMinutes());
            const seconds = pad(now.getSeconds());
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        goBack() {
            this.$router.go(-1)
        },
        showFeeReduction() {
            console.log(this.price_policy, '----')
            if(this.project_info.price_reductions && this.project_info.price_reductions >=8 ){
                this.isShowDialog = true
            }
            // if (this.price_policy) {
            this.isShowDialog = true
            //window.open(this.price_policy, "_blank");
            // }
        },
        renderMarkdown(content) {
            if (!content) return '';
            
            // Simple markdown to HTML conversion
            let html = content
                // Headers
                .replace(/^### (.*$)/gim, '<h3>$1</h3>')
                .replace(/^## (.*$)/gim, '<h2>$1</h2>')
                .replace(/^# (.*$)/gim, '<h1>$1</h1>')
                // Bold
                .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
                .replace(/__([^_]+)__/g, '<strong>$1</strong>')
                // Italic
                .replace(/\*([^*]+)\*/g, '<em>$1</em>')
                .replace(/_([^_]+)_/g, '<em>$1</em>')
                // Links
                .replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
                // Code blocks
                .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                // Inline code
                .replace(/`([^`]+)`/g, '<code>$1</code>')
                // Line breaks
                .replace(/\n/g, '<br>');
            
            return html;
        },
        formatPulseData(pulse) {
            // Extract title from content (first line or H1)
            let title = ''
            let content = pulse.content || ''
            
            // Try to extract H1 title
            const h1Match = content.match(/^#\s+(.+)$/m)
            if (h1Match) {
                title = h1Match[1].trim()
                // Remove H1 from content
                content = content.replace(/^#\s+.+$/m, '').trim()
            } else {
                // Use first line as title
                const firstLine = content.split('\n')[0].trim()
                if (firstLine && firstLine.length < 100) {
                    title = firstLine.replace(/^#+\s*/, '').trim()
                    content = content.substring(firstLine.length).trim()
                } else {
                    title = 'Announcement'
                }
            }
            
            // Use display_date if available, otherwise created_at
            const timestamp = pulse.display_date || pulse.created_at || 0
            
            // Render markdown to HTML
            const renderedContent = this.renderMarkdown(content)
            
            return {
                update_time: timestamp,
                post_title: title,
                post_content: renderedContent,
                display_date: pulse.display_date,
                created_at: pulse.created_at,
            }
        },
        doShowNewsInfo(news) {
            this.selectNews = news
            this.showNewsDialog = true
        },
        handlePaneClick(tab, event) {
            this.activePane = tab.name
        }
    }
})
</script>
<style>
.showCustomEAEPolicyDialogStyle.el-dialog{
   max-height: 88vh;
}
</style>
<style scoped lang="scss">

.product-content {
    margin-top: 20px;
    width: 100%;
    border: 1px solid #E6D7D7;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 16px;
    display: flex;

    .product-logo {
        width: 80px;
        height: 80px;
        object-fit: cover;
    }

    .middle-content {
        padding: 0px 10px;
        box-sizing: border-box;
        font-size: 14px;

        .price-container {
            border-radius: 5px;
            padding: 6px 10px;
            //box-sizing: border-box;
            background: #F8F8F8;

            .price-date {
                font-family: centurygothic;
            }

            .price {
                font-family: centurygothic;
            }

            .price-reduction {
                cursor: pointer;
                
                margin-top: 10px;
                font-family: centurygothic;
            }

        }


    }

    .right-content {
        flex: 1;
        text-align: right;
        padding: 0px 10px;
        box-sizing: border-box;

        .btn-sign {
            display: inline-block;
            padding: 12px 0;
            width: 110px;
            text-align: center;
            background-color: #ff6450;
            border-radius: 5px;
            box-sizing: border-box;
            color: white;
            font-size: 15px;
            cursor: pointer;
        }

        .desc {
            margin-top: 10px;
            color: #4A0700;
            font-size: 12px;
            font-family: centurygothic;
            line-height: 20px;
        }

        .btn-disabled {
            border-radius: 5px;
            box-sizing: border-box;
            text-align: center;
            padding: 12px 0;
            width: 110px;
            display: inline-block;
            color: #999;
            background-color: #e2e2e2;
            border: 1px solid #e2e2e2;
        }
    }
}


.product_name {
    margin-left: 10px;
    color: #333;
    font-size: 20px;
    font-family: centurygothic_bold;
}

.title {
    color: #333;
    font-size: 16px;
    font-family: centurygothic_bold;
    margin-bottom: 15px;
}

.intro_container {
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid #F0E1E1;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    padding: 20px 20px;
    font-family: centurygothic;
}


.announce-container {
    width: 100%;

    .announce-item {
        cursor: pointer;
        background-color: #F8F8F8;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 20px;
        margin-bottom: 20px;

        .announce-time {
            color: var(--c-primary);
            font-size: 14px;
            font-family: centurygothic_bold;
        }

        .announce-title {
            margin-top: 20px;
            color: #333;
            font-size: 14px;
            font-family: centurygothic_bold;
        }

        .announce-content {
            margin-top: 10px;
            color: #999;
            font-size: 12px;
            line-height: 18px;
            font-family: centurygothic;
            white-space: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            /* 定义显示的行数 */
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

}

.font_bold {
    font-weight: bold;
}

.font_red {
    color: var(--c-primary);
}

.font_under_line {
    text-decoration: underline 1px solid var(--c-primary);
    cursor: pointer;
}

.syllabus-container {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;

    .syllabus-section {
        margin-bottom: 30px;

        h3 {
            color: var(--c-primary);
            font-size: 18px;
            margin-bottom: 15px;
            border-bottom: 2px solid var(--c-primary);
            padding-bottom: 5px;
            font-family: centurygothic_bold;
        }

        ul {
            list-style-type: none;
            padding-left: 0;

            li {
                margin-bottom: 10px;
                font-size: 14px;
                line-height: 1.5;

                span {
                    font-weight: bold;
                    font-family: centurygothic_bold;
                }

                ul {
                    margin-top: 5px;
                    padding-left: 20px;

                    li {
                        font-weight: normal;
                        margin-bottom: 5px;

                        &:before {
                            content: "•";
                            color: var(--c-primary);
                            display: inline-block;
                            width: 1em;
                            margin-left: -1em;
                        }
                    }
                }
            }
        }
    }
}

.syllabus-container {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;

    .syllabus-section {
        margin-bottom: 30px;

        h3 {
            color: var(--c-primary);
            font-size: 18px;
            margin-bottom: 15px;
            border-bottom: 2px solid var(--c-primary);
            padding-bottom: 5px;
            font-family: centurygothic_bold;
        }

        ul {
            list-style-type: none;
            padding-left: 0;

            li {
                margin-bottom: 10px;
                font-size: 14px;
                line-height: 1.5;

                span {
                    font-weight: bold;
                    font-family: centurygothic_bold;
                }

                ul {
                    margin-top: 5px;
                    padding-left: 20px;

                    li {
                        font-weight: normal;
                        margin-bottom: 5px;

                        &:before {
                            content: "•";
                            color: var(--c-primary);
                            display: inline-block;
                            width: 1em;
                            margin-left: -1em;
                        }
                    }
                }
            }
        }
    }
}

.syllabus-container {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;

    .syllabus-section {
        margin-bottom: 30px;

        h3 {
            color: var(--c-primary);
            font-size: 18px;
            margin-bottom: 15px;
            border-bottom: 2px solid var(--c-primary);
            padding-bottom: 5px;
        }

        ul {
            list-style-type: none;
            padding-left: 0;

            li {
                margin-bottom: 10px;
                font-size: 14px;
                line-height: 1.5;

                span {
                    font-weight: bold;
                }

                ul {
                    margin-top: 5px;
                    padding-left: 20px;

                    li {
                        font-weight: normal;
                        margin-bottom: 5px;

                        &:before {
                            content: "•";
                            color: var(--c-primary);
                            display: inline-block;
                            width: 1em;
                            margin-left: -1em;
                        }
                    }
                }
            }
        }
    }
}

.timeline-container {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;

    .timeline-info {
        margin-bottom: 30px;
        font-size: 12px;
        color: #666;

        .info-item {
            margin-bottom: 10px;
            line-height: 1.5;

            i {
                font-style: italic;
            }

            b {
                font-weight: bold;
            }
        }
    }

    .timeline-cycle {
        margin-bottom: 50px;


        h3 {
            color: var(--c-primary);
            font-size: 18px;
            margin-bottom: 15px;
            border-bottom: 2px solid var(--c-primary);
            padding-bottom: 10px;
        }

        .el-table {
            margin-top: 15px;

            .el-table__header-wrapper th {
                background-color: #f0f0f0;
                color: #333;
                padding: 15px 10px;

                &:first-child {
                    padding-left: 20px;
                }
            }

            .el-table__body-wrapper td {
                padding: 15px 10px;

                &:first-child {
                    padding-left: 20px;
                }
            }
        }
    }

    .exam-times {


        h3 {
            color: var(--c-primary);
            font-size: 18px;
            margin-bottom: 15px;
            border-bottom: 2px solid var(--c-primary);
            padding-bottom: 10px;
        }

        .el-table {
            margin-top: 15px;

            .el-table__header-wrapper th {
                background-color: #f0f0f0;
                color: #333;
                padding: 15px 10px;
            }

            .el-table__body-wrapper td {
                padding: 15px 10px;
            }
        }
    }

    .timeline-note {
        margin-bottom: 30px;
        padding: 15px;
        background-color: #f9f9f9;
        border-left: 4px solid var(--c-primary);
        border-radius: 4px;

        p {
            margin-bottom: 10px;
            font-size: 14px;
            line-height: 1.5;
            color: #666;

            &:last-child {
                margin-bottom: 0;
            }

            i {
                font-style: italic;
            }

            b {
                font-weight: bold;
                color: #333;
            }
        }
    }

}

.sample-questions-container {
    margin-top: 20px;

    .sample-question {
        background-color: #f9f9f9;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 30px;

        h3 {
            color: var(--c-primary);
            font-size: 18px;
            margin-bottom: 15px;
            border-bottom: 2px solid var(--c-primary);
            padding-bottom: 5px;
        }

        .question {
            font-size: 16px;
            margin-bottom: 15px;
            line-height: 1.5;
        }

        .options {
            list-style-type: none;
            padding-left: 0;

            li {
                margin-bottom: 10px;
                font-size: 14px;
            }
        }

        .correct-answer,
        .explanation {
            margin-top: 15px;
            font-size: 14px;
            line-height: 1.5;
        }

        .explanation {
            background-color: #e6f7ff;
            border-left: 4px solid #1890ff;
            padding: 10px;
            border-radius: 4px;
        }
    }
}
</style>
